import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getBeneficiaries, updateBeneficiaries } from '../../../services/members';
import { useFieldArray, useForm } from 'react-hook-form';
import Input from '../../../components/Forms/Input';
import Toast from '../../../components/Common/Toast';
import { isValidBeneficiaryAllocation } from '../../../utils/validators';

const BeneficiaryForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const { control, handleSubmit, setValue, watch } = useForm({
    defaultValues: { beneficiaries: [] },
  });
  const { fields, append, remove } = useFieldArray({ control, name: 'beneficiaries' });

  useEffect(() => {
    loadBeneficiaries();
  }, [id]);

  const loadBeneficiaries = async () => {
    try {
      const data = await getBeneficiaries(id);
      setValue('beneficiaries', data);
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to load beneficiaries' });
    }
  };

  const onSubmit = async (data) => {
    if (!isValidBeneficiaryAllocation(data.beneficiaries)) {
      setToast({ type: 'error', message: 'Total allocation must equal 100%' });
      return;
    }
    setLoading(true);
    try {
      await updateBeneficiaries(id, data.beneficiaries);
      setToast({ type: 'success', message: 'Beneficiaries updated' });
      navigate(`/dashboard/org-admin/members/${id}`);
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h1>Manage Beneficiaries</h1>
      <form onSubmit={handleSubmit(onSubmit)}>
        {fields.map((field, index) => (
          <div key={field.id} style={{ border: '1px solid #ddd', padding: '1rem', marginBottom: '1rem' }}>
            <Input name={`beneficiaries.${index}.full_name`} control={control} label="Full Name" />
            <Input name={`beneficiaries.${index}.relationship`} control={control} label="Relationship" />
            <Input name={`beneficiaries.${index}.allocation`} control={control} label="Allocation %" type="number" />
            <button type="button" onClick={() => remove(index)}>Remove</button>
          </div>
        ))}
        <button type="button" onClick={() => append({ full_name: '', relationship: '', allocation: 0 })}>Add Beneficiary</button>
        <button type="submit" disabled={loading}>Save</button>
      </form>
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default BeneficiaryForm;